import { LinkProps } from "next/link"
import React from "react"
import styled from "styled-components"

import TransitionLink from "~/components/atoms/TransitionLink"
import { Color, LineHeight, SpacingSize } from "~/consts/style-mixins"

type Props = {
  href: LinkProps["href"]
  message?: string
  /** @default Color.Secondary */
  bgColor?: string
  className?: string
}

const FlowMessage: React.FC<Props> = ({ href, message, bgColor, className, children }) => {
  return (
    <StyledMessage bgColor={bgColor ?? Color.Secondary} className={className}>
      <div>
        <StyledTransitionLink size="Small" icon="Next" href={href}>
          {message}
          {children}
        </StyledTransitionLink>
      </div>
    </StyledMessage>
  )
}

const StyledMessage = styled.div<{ bgColor: string }>`
  display: flex;
  justify-content: center;
  line-height: ${LineHeight._2XS}%;
  padding: 7.25px ${SpacingSize.M}px;
  background: ${({ bgColor }) => bgColor};
  & > div {
    & a,
    svg {
      color: ${Color.White};
      fill: ${Color.White};
    }
  }
  & > div:hover {
    & a,
    svg {
      color: ${Color.White};
      fill: ${Color.White};
      opacity: 0.6;
    }
  }
`

const StyledTransitionLink = styled(TransitionLink)`
  margin-left: ${SpacingSize._3XS}px;
`

export default FlowMessage
